import { formatFullDateTime } from '@/utils/formatDate'
import { maskNickname } from '@/utils/maskNickname'
import emptyIcon from '../assets/empty.png'

interface Member {
  consumer_id: string
  nickname: string
  joined_at: string
}

interface MemberListProps {
  members: Member[]
  isLoading: boolean
  onInvite: () => void
}

export function MemberList(props: MemberListProps) {
  return (
    <div className='mt-[24px] flex w-full flex-col px-[20px]'>
      <div className='w-full'>
        <h3 className='mb-[12px] text-[16px] font-bold leading-[19px] text-[#1a1a1a]'>
          Recently Joined
        </h3>

        <div className='flex h-[40px] w-full items-center rounded-t-[12px] bg-[#F5F5F5] px-[16px]'>
          <span className='w-1/2 text-[12px] font-medium text-[#666]'>
            Member
          </span>
          <span className='w-1/2 text-right text-[12px] font-medium text-[#666]'>
            Joined Time
          </span>
        </div>

        <div className='w-full'>
          {props.isLoading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <div
                key={`skeleton-${index}`}
                className='flex h-[60px] items-center justify-between border-b border-[#F5F5F5] px-[4px]'
                data-testid={`member-skeleton-${index}`}
              >
                <div className='flex items-center gap-[10px]'>
                  <div className='h-[16px] w-[100px] animate-pulse rounded bg-gray-100' />
                </div>
                <div className='h-[14px] w-[80px] animate-pulse rounded bg-gray-50' />
              </div>
            ))
          ) : props.members && props.members.length > 0 ? (
            props.members.map((member, index) => (
              <div
                key={member.consumer_id}
                className='flex h-[60px] items-center justify-between border-b border-[#F5F5F5] px-[4px]'
                data-testid={`member-row-${index}`}
              >
                <div className='flex items-center gap-[10px]'>
                  <span className='text-[14px] font-semibold text-[#1a1a1a]'>
                    {maskNickname(member.nickname)}
                  </span>
                </div>
                <span className='text-[12px] text-[#999]'>
                  {formatFullDateTime(member.joined_at)}
                </span>
              </div>
            ))
          ) : (
            <div
              className='mt-[60px] flex flex-col items-center justify-center pb-[40px]'
              data-testid='empty-state'
            >
              <img
                src={emptyIcon}
                alt='No data'
                className='h-auto w-[180px]'
                data-testid='empty-state-image'
              />
              <p className='mt-[16px] text-center text-[14px] text-[#999]'>
                No users have joined the team yet
              </p>
              <button
                onClick={props.onInvite}
                className='mt-[24px] flex h-[48px] w-[200px] items-center justify-center rounded-[24px] bg-[#6e59cd] text-[16px] font-bold text-white shadow-[0px_8px_16px_rgba(110,89,205,0.25)] transition-transform active:scale-95'
                data-testid='empty-state-invite-button'
              >
                Invite Now
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
